import { FC, useMemo } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { IProgramPageSimilarPrograms } from '../types'
import { useSimilarPrograms } from '../bll/useSimilarPrograms'
import ProgramList from '../../../../../../components/ProgramList/desktop'

const ProgramPageSimilarPrograms: FC<IProgramPageSimilarPrograms> = (props) => {
  const { id, institutionId, type } = props

  const { programs, programIds } = useSimilarPrograms({
    programId: id,
    institutionIds: [institutionId],
    limit: 3,
  })

  const title = useMemo(() => {
    const { value } = type

    if (value === 1) return 'Другие программы вуза'

    if (value === 2) return 'Другие программы колледжа'

    if (value === 3) return 'Другие программы школы'

    if (value === 5) return 'Другие программы учебного центра'

    return 'Другие программы учебного заведения'
  }, [type])

  if (!programs || programs.length === 0) return null

  return (
    <>
      <Heading h2={title} spacing='large' />

      <ProgramList
        isButtonsIcon={false}
        items={programs}
        selectedIds={programIds}
        showLogo={false}
        showButtons
        showExamsInProfile={false}
      />

      <Spacing spacing='uxlarge' />
    </>
  )
}

export default ProgramPageSimilarPrograms
